/** @jsx jsx */
import { Link } from "gatsby"
import Img from "gatsby-image"
import { Box, Card, Grid, Heading, jsx, Link as TLink } from "theme-ui"

const BookPreview = ({ book }) => (
  <Card my={3}>
    <Grid gap={4} px={3} py={2} columns={[1, 1, "1.5fr 4.5fr"]}>
      <Box sx={{ margin: "auto 0" }}>
        <TLink as={Link} to={book.slug}>
          <Img fluid={book.cover.childImageSharp.fluid} />
        </TLink>
      </Box>
      <Box sx={{ margin: "auto 0" }}>
        <TLink as={Link} to={book.slug}>
          <Heading mb={2}>{book.title}</Heading>
          <p sx={{ color: "text" }}>{book.overview}</p>
        </TLink>
      </Box>
    </Grid>
  </Card>
)

export default BookPreview
